import { Button, Dialog, DialogContent, Box, Avatar, TextField } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useState } from "react";
import { ApiRequest } from 'GlobalFunctions';
import { PiWarningCircle } from "react-icons/pi";


export default function CancelSubscriptionDialog(props: any) {
    const { 
        open, 
        setOpen, 
        loading,
        subscription_id,
        next_billing_date,
        loadSubscriptionDetails
    } = props;
    
    const [cancelReason, setCancelReason] = useState<string>('');

    const submitCancelSubscription = () => {
        ApiRequest({
            url: '/subscriptions/cancel',
            method: 'POST',
            body: {
                subscription_id: subscription_id,
                cancel_reason: cancelReason
            },
            setResponse: (response: any) => {
                setOpen(false);
                setCancelReason('');
                if (loadSubscriptionDetails) {
                    loadSubscriptionDetails();
                }
            }
        });
    }

    const formatDate = (dateString: string) => {
        if (!dateString) return '';
        // Parse the date string and treat it as local time to avoid timezone shifts
        const date = new Date(dateString);
        // Use UTC methods to avoid timezone conversion issues
        return date.toLocaleDateString('en-US', { 
            month: 'short', 
            day: 'numeric', 
            year: 'numeric',
            timeZone: 'UTC'
        });
    };

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
        >
            <DialogContent style={{ padding: '0', maxWidth: '530px' }}>
                <div className="cancel_dialog_content" style={{ padding: '60px 60px 30px 60px'}}>
                    <div className="cancel_dialog_header">
                        <Avatar sx={{ bgcolor: '#FCF2F2', width: 40, height: 40 }}>
                            <PiWarningCircle color="#CA3A31" size={20} />
                        </Avatar>
                        <h3 className='heading_h3_dialog'>Cancel Subscription</h3>
                    </div>

                    <p style={{ 
                        fontSize: '14px', 
                        color: '#666666', 
                        marginBottom: '50px',
                        lineHeight: '1.5',
                        textAlign: 'center'
                    }}>
                        Cancel to stop recurring billing. This subscription will still be in use until {formatDate(next_billing_date)}.
                    </p>

                    <div style={{ marginBottom: '20px' }}>
                        <h4 style={{ 
                            fontWeight: '400', 
                            fontSize: '14px', 
                            marginBottom: '8px', 
                            color: '#B9B9BA' 
                        }}>
                            Please briefly describe what led to this decision.
                        </h4>
                        <TextField
                            fullWidth
                            multiline
                            rows={4}
                            
                            placeholder="eg. reasons for cancellation"
                            value={cancelReason}
                            onChange={(e) => setCancelReason(e.target.value)}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '8px',
                                    backgroundColor: '#FFFFFF',
                                },
                            }}
                        />
                    </div>

                    <Box
                        sx={{
                            backgroundColor: '#F8E3E3',
                            color: '#CA3A31',
                            padding: '10px',
                            borderRadius: '8px',
                            fontSize: '12px',
                            marginBottom: '20px',
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: '8px',
                            textAlign: 'center'
                        }}
                    >
                        <span>
                            Canceling now means any applied promotion or discount will be removed, resubscribing will be standard rates.
                        </span>
                    </Box>
                </div>

                <div className="cancel_subs_dialog_actions">
                    <Button
                        variant="text"
                        color="primary"
                        onClick={() => setOpen(false)}
                        sx={{
                            borderColor: '#B9B9B9',
                            borderRadius: '5px !important',
                            color: '#424242',
                            padding: '6px 10px !important',
                            marginRight: '10px'
                        }}
                    >
                        Cancel
                    </Button>
                    <LoadingButton
                        variant="contained"
                        color="primary"
                        onClick={submitCancelSubscription}
                        loading={loading}
                        sx={{
                            padding: '6px 10px !important',
                        }}
                    >
                        Confirm
                    </LoadingButton>
                </div>
            </DialogContent>
        </Dialog>
    )
}
